/* Back to School Deal promo: click-to-copy code + live countdown + auto-hide on expiry. */
if (!customElements.get('promo-copy')) {
  customElements.define('promo-copy', class PromoCopy extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code || '';
      this.btn = this.querySelector('[data-copy]');
      if (this.btn) this.btn.addEventListener('click', () => this.copy());

      var end = parseInt(this.dataset.deadline, 10);
      this.deadline = isNaN(end) ? 0 : end * 1000;
      if (this.deadline) {
        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    copy() {
      var self = this;
      var done = function () {
        var a = self.querySelector('[data-action-text]');
        self.classList.add('is-copied');
        var prev = a ? a.textContent : '';
        if (a) a.textContent = 'Copied ✓';
        clearTimeout(self._reset);
        self._reset = setTimeout(function () {
          self.classList.remove('is-copied');
          if (a) a.textContent = prev;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.code).then(done).catch(function () { self.fallback(done); });
      } else {
        this.fallback(done);
      }
    }

    fallback(done) {
      var t = document.createElement('textarea');
      t.value = this.code;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.top = '-9999px';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(t);
    }

    tick() {
      var diff = this.deadline - Date.now();
      if (diff <= 0) {
        if (this.timer) clearInterval(this.timer);
        this.style.display = 'none';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      this.set('[data-dd]', d);
      this.set('[data-hh]', h);
      this.set('[data-mm]', m);
      this.set('[data-ss]', s);
    }

    set(sel, v) {
      var el = this.querySelector(sel);
      if (el) el.textContent = String(v).padStart(2, '0');
    }
  });
}
